import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const rewardItemsStatusOptions = [
  { label: 'Ativa', value: 'active' },
  { label: 'Desabilitada', value: 'disabled' },
]

export const rewardItemsStatusStrategy = optionsToStrategy(rewardItemsStatusOptions)
